import React, {useEffect} from 'react';

import classNames from 'classnames';
import {Container} from 'reactstrap';
import {useParams} from 'react-router';

import ContentTable from 'components/Contents/ContentTable';
import StatusBadge from 'components/Badges/StatusBadge';
import {CB_ACCREDITATION_COLORS} from 'configs';

import useGetCBStandards from './useGetCBStandards';

import styles from '../styles.module.scss';

function CBAccreditationScopeStandardSchemes(props) {
  const {selectedAB} = props;

  const {cbId} = useParams();

  const {accreditation_bodies_id} = selectedAB || {};
  const {isLoading, data, meta, reload} = useGetCBStandards(
    cbId,
    accreditation_bodies_id
  );
  const {total_rows} = meta || {};

  useEffect(() => {
    if (!!selectedAB) reload(accreditation_bodies_id);
  }, [selectedAB]);

  return (
    <Container className="p-0" tag="section">
      <h3 className={classNames(styles['section__title'], 'mb-4')}>
        Standards and Schemes {`(${total_rows || 0})`}
      </h3>

      <Container className={styles['table-container']}>
        <ContentTable
          v2
          hover={false}
          className="mb-0"
          minHeight="364px"
          responsive={false}
          isFetching={isLoading}
          head={['Accreditation Status', 'Standard', 'Scheme']}
        >
          {data.map((item, index) => {
            const {standards_name, scheme_name, status} = item;

            return (
              <tr key={index}>
                <td>
                  <StatusBadge
                    pill
                    large
                    status={status}
                    colors={CB_ACCREDITATION_COLORS}
                    className="text-white"
                  />
                </td>
                <td>{standards_name}</td>
                <td>{scheme_name}</td>
              </tr>
            );
          })}
        </ContentTable>
      </Container>
    </Container>
  );
}

export default CBAccreditationScopeStandardSchemes;
